import I18N from '@leverege/i18n';
const id = 'rsrc.dataViewers.actions.PlayPause';
const {
  t,
  tIcon
} = I18N.ns(id);
export default {
  id,
  name: t('name'),
  matches: {
    client: 'TimelineScrubber',
    use: 'playBar'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    const {
      isPlaying,
      loading
    } = context;
    return {
      // name : isPlaying ?
      //   t( 'pause' ) :
      //   loading ?
      //     t( 'loading' ) :
      //     t( 'play' ),
      icon: isPlaying ? tIcon('iconPause', 'fa fa-fw fa-pause') : loading ? tIcon('iconLoading', 'fa fa-fw fa-spinner fa-spin') : tIcon('iconPlay', 'fa fa-fw fa-play'),
      checked: isPlaying,
      checkStyle: 'toggle',
      disabled: loading && !isPlaying
    };
  },
  perform: ({
    context
  }) => {
    const {
      onPlayPause,
      isPlaying
    } = context;
    onPlayPause({
      value: !isPlaying
    });
  }
};